import { Helmet } from 'react-helmet';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Categories = () => {
  return (
    <>
      <Helmet>
        <title>Categories | InvizHer - Browse Programming & Tech Topics</title>
        <meta name="description" content="Browse content by category including web development, programming tutorials, technology guides, and development resources. Find exactly what you're looking for." />
        <meta name="keywords" content="categories, programming topics, web development categories, tech topics, coding tutorials, development guides" />
        <link rel="canonical" href="https://invizher.com/categories" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://invizher.com/categories" />
        <meta property="og:title" content="Browse Categories | InvizHer" />
        <meta property="og:description" content="Browse content by category - web development, programming, tutorials, and more." />
        <meta property="og:site_name" content="InvizHer" />
        
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Categories | InvizHer" />
        <meta name="twitter:description" content="Browse programming and tech topics by category." />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-32 pb-20" role="main">
          {/* Hero Section */}
          <section className="container mx-auto px-4 mt-8 mb-16">
            <div className="text-center max-w-3xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Explore All <span className="gradient-text">Categories</span>
              </h1>
              <p className="text-gray-600 text-lg mb-8">
                Discover curated content across various topics, from cutting-edge technology to mindful lifestyle choices
              </p>
            </div>
          </section>

          {/* Categories Grid */}
          <section className="container mx-auto px-4">
            <div className="grid gap-6 grid-cols-1 md:grid-cols-2">
              {/* Technology Category */}
              <a href="/category/technology" className="glass-morphism rounded-2xl overflow-hidden hover:shadow-xl transition-all">
                <div className="p-6 md:p-8">
                  <div className="flex items-start justify-between mb-6">
                    <div className="bg-blue-500/10 w-16 h-16 rounded-2xl flex items-center justify-center">
                      <i className="fas fa-microchip text-blue-500 text-2xl"></i>
                    </div>
                    <span className="px-4 py-1 bg-blue-500/10 text-blue-500 rounded-full text-sm">
                      24 Articles
                    </span>
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold mb-3">Technology</h3>
                  <p className="text-gray-600 mb-6">
                    Explore the latest in AI, blockchain, cybersecurity, and emerging tech trends shaping our future.
                  </p>
                </div>
              </a>

              {/* Design Category */}
              <a href="/category/design" className="glass-morphism rounded-2xl overflow-hidden hover:shadow-xl transition-all">
                <div className="p-6 md:p-8">
                  <div className="flex items-start justify-between mb-6">
                    <div className="bg-purple-500/10 w-16 h-16 rounded-2xl flex items-center justify-center">
                      <i className="fas fa-palette text-purple-500 text-2xl"></i>
                    </div>
                    <span className="px-4 py-1 bg-purple-500/10 text-purple-500 rounded-full text-sm">
                      18 Articles
                    </span>
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold mb-3">Design</h3>
                  <p className="text-gray-600 mb-6">
                    Dive into UI/UX principles, graphic design trends, and creative inspiration for modern designers.
                  </p>
                </div>
              </a>

              {/* Development Category */}
              <a href="/category/development" className="glass-morphism rounded-2xl overflow-hidden hover:shadow-xl transition-all">
                <div className="p-6 md:p-8">
                  <div className="flex items-start justify-between mb-6">
                    <div className="bg-green-500/10 w-16 h-16 rounded-2xl flex items-center justify-center">
                      <i className="fas fa-code text-green-500 text-2xl"></i>
                    </div>
                    <span className="px-4 py-1 bg-green-500/10 text-green-500 rounded-full text-sm">
                      32 Articles
                    </span>
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold mb-3">Development</h3>
                  <p className="text-gray-600 mb-6">
                    Master programming languages, frameworks, and best practices for modern development.
                  </p>
                </div>
              </a>

              {/* Lifestyle Category */}
              <a href="/category/lifestyle" className="glass-morphism rounded-2xl overflow-hidden hover:shadow-xl transition-all">
                <div className="p-6 md:p-8">
                  <div className="flex items-start justify-between mb-6">
                    <div className="bg-red-500/10 w-16 h-16 rounded-2xl flex items-center justify-center">
                      <i className="fas fa-leaf text-red-500 text-2xl"></i>
                    </div>
                    <span className="px-4 py-1 bg-red-500/10 text-red-500 rounded-full text-sm">
                      15 Articles
                    </span>
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold mb-3">Lifestyle</h3>
                  <p className="text-gray-600 mb-6">
                    Discover wellness tips, productivity hacks, and personal growth strategies for a balanced life.
                  </p>
                </div>
              </a>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Categories;
